// components/MobileBottomBar.jsx
import { NAV_ITEMS } from "./navItems";
import { getAvatarUrlFromUser, getDisplayName } from "../utils/avatarUtils";
import { useTranslation } from "react-i18next";
import { useNotifications } from "../context/NotificationContext";
import { useAuth } from "../context/AuthContext";

export default function MobileBottomBar({ active, onSelect, user }) {
    const { t } = useTranslation();
    const { isAuthenticated } = useAuth();
    const { unreadCount } = useNotifications();
    const avatarUrl = getAvatarUrlFromUser(user);
    const displayName = getDisplayName(user);

    return (
        <nav
            className="
        md:hidden fixed inset-x-0 bottom-0 z-50
        bg-card-light dark:bg-card-dark
        border-t border-border-light dark:border-border-dark
        px-1.5 sm:px-2 pt-3
        pb-[calc(env(safe-area-inset-bottom)+8px)]
      "
            role="navigation"
            aria-label={t('common.bottom_navigation', { defaultValue: 'Bottom navigation' })}
        >
            <div className="w-full h-full">
                <ul className="flex w-full h-full items-stretch">
                    {NAV_ITEMS.map((item) => {
                        if (item.key === "notifications" && !isAuthenticated) return null;
                        const isActive = active === item.key;
                        return (
                            <li key={item.key} className="flex-1">
                                <button
                                    onClick={() => onSelect(item.key)}
                                    className={[
                                        "w-full h-full flex flex-col items-center justify-center gap-1.5",
                                        isActive
                                            ? "text-primary"
                                            : "text-foreground-light dark:text-foreground-dark",
                                    ].join(" ")}
                                    aria-current={isActive ? "page" : undefined}
                                >
                                    <div className="relative">
                                        <svg
                                            className="w-6 h-6 sm:w-7 sm:h-7"
                                            viewBox="0 0 256 256"
                                            fill="currentColor"
                                            aria-hidden="true"
                                        >
                                            <path d={item.iconPath} />
                                        </svg>
                                        {item.key === "notifications" && unreadCount > 0 && (
                                            <span className={`absolute -top-1 -right-1 flex h-4 items-center justify-center rounded-full bg-danger-light dark:bg-danger-dark text-[9px] font-bold text-white leading-none shadow-sm animate-heart-beat shrink-0 ${
                                                unreadCount < 10 ? "w-4 px-0" : "min-w-[16px] px-1"
                                            }`}>
                                                {unreadCount}
                                            </span>
                                        )}
                                    </div>
                                    <span className="text-[11px] sm:text-[12px] font-bold leading-none text-center">
                                        {t(`common.${item.key}`, { defaultValue: item.label })}
                                    </span>
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </nav>
    );
}